import { Html5QrcodeScanner } from "html5-qrcode";
const QrCodeScanning = {}
QrCodeScanning.test = () =>{
    console.log("Hello world");
}
QrCodeScanning.openScanner = (studentList,setStudentList)=>{
    let students = studentList.map((student)=>{
        return {data:btoa(student.name+"-"+student.email),student:student}
    })
    console.log(students);
    html5QrcodeScanner = new Html5QrcodeScanner(
        "reader",
        { fps: 10, qrbox: {width: 250, height: 250} },
        /* verbose= */ false);
        html5QrcodeScanner.render((decodedText, decodedResult)=>{
            for(let student of students){
                if(student.data === decodedText){
                    upDateAttendance(student.student,studentList,setStudentList);
                    break;
                }
            }
        }, onScanFailure);
}
QrCodeScanning.closeScanner = (e) =>{
    e.preventDefault();
    html5QrcodeScanner.clear();
}

function onScanFailure(error) {
    // handle scan failure, usually better to ignore and keep scanning.
    // for example:
    // console.warn(`Code scan error = ${error}`);
}
const upDateAttendance = async (student,studentList,setStudentList) =>{
    console.log(JSON.stringify(student));
    let record = student.attendance;
    if(record === undefined){
        record = [];
    }
    if(!record.includes(new Date().toDateString())){
        record.push(new Date().toDateString());
    }
    let toSave = {}
    toSave.attendance = record
    let res = await fetch(`http://localhost:5000/students/${student.id}`,{
        method:"PATCH",
        headers:{
            'Content-Type':"application/json"
        },
        body:JSON.stringify(toSave)
    })
    let data = await res.json();
    console.log("Data Bounce Back")
    console.log(data);
    let newStudentList = studentList.map((stud)=>{
        if(stud.id === data.id){
            return data;
        }else{
            return stud;
        }
    })
    console.log("New Student LIst");
    console.log(newStudentList);
    setStudentList(newStudentList)
}
let html5QrcodeScanner = null
export default QrCodeScanning